var $d80cdcd4f4ee154e$exports = {};
$d80cdcd4f4ee154e$exports = {
    "actions": `Radnje`,
    "hideButtonLabel": `Prika\u{17E}i manje`,
    "noTags": `Nema`,
    "showAllButtonLabel": (args, formatter)=>`Prika\u{17E}i sve (${formatter.number(args.tagCount)})`
};


export {$d80cdcd4f4ee154e$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
